































































































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
// import { pageDataType, componentDataType } from "../types";
import { HOST } from "../global";
import { FETCH_QUARTERLY_REPORTS } from "../store/actions.names";
import { pageDataType, componentDataType } from "../types";
@Component({
  name: "FinancialStatement"
})
export default class FinancialStatement extends Vue {
  @Prop() public compData!: string | null;
  @Action(FETCH_QUARTERLY_REPORTS) fetchQuarterlyReports: any;
  public HOST: string = HOST;
  title!: string[];
  reports: any = [];
  filter = {
    quarter: null,
    year: null
  };
  public accordionIndex = 0;
  quarterLabels = {
    1: "First Quarter",
    2: "Second Quarter",
    3: "Third Quarter"
  };

  get assortedReports() {
    let reports: { [key: string]: any[] } = {};
    this.reports.map((item: any, idx: number) => {
      if (this.filter.year === null || this.filter.year == item.year) {
        if (!(item.year in reports)) {
          reports[item.year] = [];
        }
      }
      if (
        item.year in reports &&
        (this.filter.quarter === null || this.filter.quarter == item.quarter)
      ) {
        reports[item.year].push(item);
      }
    });
    for (const key in reports) {
      if (reports.hasOwnProperty(key)) {
        reports[key].sort();
      }
    }
    return reports;
  }

  get sortedYears() {
    let years = Object.keys(this.assortedReports);
    years.sort().reverse();
    return years;
  }

  // @Watch("sortedYears")
  // handleAssortedReportsChange(val: any, oldVal: any) {
  //   this.filter.year = this.sortedYears[0];
  // }
  // year: string = "2018";
  // year: any = [];
  //  @Watch("year", {
  //     immediate: true
  // })
  // public data() {
  //     return {
  //       //  selectedQuarter: "All",
  //        // selectedYear: '',

  //     };
  // }

  // computed_items() {
  //   let filterType = this.selectedYear;
  //   return this.compData.financial_quarter_list.filter(function(item){
  //     let filtered = true
  //     if(filterType && filterType.length > 0){
  //       filtered = item.type == filterType
  //     }
  //     if(filtered){
  //       if(filterSize && filterSize.length > 0){
  //         filtered = item.size == filterSize
  //       }
  //     }
  //     return filtered
  //   })
  // }

  //  filterData(){
  //         const selectedYear = this.compData.financial_quarter_list.filter((val: any, index: number) => {
  //             return val.type == "year"
  //         }).map((val: any, idx: number) => {
  //             return val.value.call_to_action.id
  //         });
  //         return this.campaignData.filter((val, idx) => {
  //             return selectedCampaigns.indexOf(val.id) == -1;
  //         })
  //     }

  public mounted() {
    // this.filteredquarter();
    this.fetchQuarterlyReports().then((data: any) => {
      this.reports = data;
    });
  }
}
